export default "__VITE_ASSET__f2f9f7b2__"